export default __webpack_public_path__ + "static/about-us-l5-img-55b10d5fb6812340b0e3268add97be39.png";